<div class="dialog-header flex justify-content-between align-items-center gap-2">
  <h2>Refuzare borderou</h2>
  <p-button
    mat-dialog-close
    size="small"
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content class="pb-2">
  <p>
    Sunteți pe cale să refuzați un borderou
    @if (preInvoice.period.start && preInvoice.period.end) {
      din perioada
      <b>
        {{ preInvoice.period.start | date: "dd/MM/yyyy" }} -
        {{ preInvoice.period.end | date: "dd/MM/yyyy" }}
      </b>
    }
    în valoare de
    <b>{{ preInvoice.grossAmount | currency: "RON" }}</b>.
  </p>
  <p>Zona aferentă borderoului: <b>{{ preInvoice.zone.name }}</b></p>

  <p class="m-0 mb-2 font-bold">Motivul refuzării</p>
  <input
    pInputText
    class="w-full"
    [formControl]="reasonControl"
  >
  @if (reasonControl.errors && reasonControl.dirty) {
    <small class="text-red-500">Câmpul este obligatoriu</small>
  }

  @switch (preInvoice.status) {
    @case ("APPROVED_PENDING") {
      <p class="text-red-500">
        <b>
          Atenție! Borderoul este în curs de procesare pentru generarea facturii. Dacă anulați această operațiune, borderoul va
          reveni la starea inițială.
        </b>
      </p>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="flex align-items-center gap-2">
    <button
      pButton
      label="Anulează borderou"
      size="small"
      severity="danger"
      icon="pi pi-trash"
      iconPos="left"
      (click)="reject()"
    ></button>

    <button
      pButton
      mat-dialog-close
      label="Închide"
      size="small"
      [text]="true"
    ></button>
  </div>
</mat-dialog-actions>
@if (loading()) {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}